import { defineStore } from 'pinia'
import AppConfig from '@/settings.js'

const { showSettings, tagsView, fixedHeader, sidebarLogo } = (AppConfig as AppConfigType)

export const settingStore = defineStore('setting', {
  state: () => {
    return {
      config: {
        theme: '',
        showSettings: showSettings,
        tagsView: tagsView,
        fixedHeader: fixedHeader,
        sidebarLogo: sidebarLogo
      }
    }
  },
  actions: {
    changeSetting(set: AppSettingType) {
      this.config = { ...this.config, ...set }
    }
  },
  getters: {
    theme: (state) => state.config.theme,
    showSettings: (state) => state.config.showSettings,
    tagsView: (state) => state.config.tagsView,
    fixedHeader: (state) => state.config.fixedHeader,
    sidebarLogo: (state) => state.config.sidebarLogo,
  }
})